// node modules
import { observable, action } from 'mobx';
// constants
import { ITVOrder } from 'modules/TradingChart/components/TradingView/utils/providers/brokerProvider/orders/types';

export class OrdersStore {
  @observable orders: Order[] = [];
  @observable tvOrders: ITVOrder[] = [];

  // Actions
  @action setOrders = (orders: Order[]) => {
    this.orders = orders;
  };

  @action updateOrders = (order: Order, index: number) => {
    this.orders[index] = order;
  };

  @action addOrder = (order: Order) => {
    this.orders = [...this.orders, order];
  };

  @action updateTvOrders = (order: ITVOrder, index: number) => {
    this.tvOrders[index] = order;
  };

  @action addTvOrder = (order: ITVOrder) => {
    this.tvOrders = [...this.tvOrders, order];
  };

  @action setTvOrders = (orders: ITVOrder[]) => {
    this.tvOrders = orders;
  };
}
